/** Raw columns of My Characters' single SELECT. JSON aggregates remain MySQL JSON strings. */
type DbNumber = number | string | null;

export interface PlayerCharacterClassSlot {
    class_id: string | null;
    subclass_id: string | null;
    level: DbNumber;
    item_name: string | null;
}

/** Total character level: the sum of the saved class slots' levels (what the creature compile reports as total_level). */
export function playerCharacterTotalLevel(slots: readonly Pick<PlayerCharacterClassSlot, 'level'>[]): number {
    let level = 0;
    for (const slot of slots) {
        const value = Number(slot.level ?? 0);
        if (Number.isFinite(value)) level += Math.trunc(value);
    }
    return level;
}

export interface PlayerCharacterListPicture {
    picture_i: DbNumber;
    picture_id: string;
    picture_extension: string | null;
    primary_picture: DbNumber;
    picture_thumbnail: DbNumber;
    picture_number: DbNumber;
    picture_attached_item_type: string;
    picture_reference_attached_item_type: string | null;
}

export interface PlayerCharacterListRow {
    item_id: string;
    player_name: string | null;
    attached_campaign_id: string | null;
    player_character_inactive: DbNumber;
    player_character_allow_copying: DbNumber;
    player_character_private: DbNumber;
    encounter_creature_id: string | null;
    creature_number: DbNumber;
    campaign_id: string | null;
    campaign_name: string | null;
    class_slots_json: string | PlayerCharacterClassSlot[];
    pictures_json: string | PlayerCharacterListPicture[] | null;
}
